import { Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export interface NoObjectMessageProps {
    informativeMessage: string;
    actionMessage?: string;
}

function NoObjectMessage({ informativeMessage, actionMessage }: NoObjectMessageProps) {
    return (
        <>
            <Stack alignItems="center" width="100%">
                {informativeMessage && (
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 700,
                            color: '#9E9E9E'
                        }}
                    >
                        <FormattedMessage id={informativeMessage} defaultMessage={informativeMessage} />
                    </Typography>
                )}
                {actionMessage && (
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 500,
                            color: '#9E9E9E'
                        }}
                    >
                        <FormattedMessage id={actionMessage} defaultMessage={actionMessage} />
                    </Typography>
                )}
            </Stack>
        </>
    );
}

export default NoObjectMessage;
